import React from "react"
import PropTypes from "prop-types"
import {
  APIProvider,
  Map as GoogleMap,
} from "@vis.gl/react-google-maps"
import MarkersLayer from "./MarkersLayer"

const MAP_ID = "725a56243381c957"

declare global {
  interface Window {
    MAPS_API_KEY: string
  }
}

export type Point = {
  id: string
  address: string
  lat: number
  lng: number
  schedule: {
    [key: string]: [string]
  }
}

const defaultCenter = {
  lat: 48.6,
  lng: 31.3,
}

const defaultZoomValue = 10
const globalLanguage = document.documentElement.lang || "uk"

export default function Map({
  selectedPoint = null,
  setSelectedPoint = () => {},
  pointsList = [],
  defaultCenter: center = defaultCenter,
  defaultZoom: zoom = defaultZoomValue,
}: {
  selectedPoint?: string | null
  setSelectedPoint?: (pointId: string) => void
  pointsList?: Point[]
  defaultCenter?: { lat: number; lng: number }
  defaultZoom?: number
}) {
  return (
    <APIProvider
      apiKey={window.MAPS_API_KEY}
      libraries={["places"]}
      language={globalLanguage}
    >
      <GoogleMap
        defaultCenter={center}
        defaultZoom={zoom}
        mapId={MAP_ID}
        minZoom={3}
        maxZoom={20}
        scaleControl={true}
        mapTypeControl={false}
        streetViewControl={false}
        fullscreenControl={false}
        gestureHandling={"greedy"}
      >
        {pointsList && (
          <MarkersLayer
            pointsList={pointsList}
            setSelectedPoint={setSelectedPoint}
            selectedPoint={selectedPoint}
          />
        )}
      </GoogleMap>
    </APIProvider>
  )
}

Map.propTypes = {
  selectedPoint: PropTypes.string,
  setSelectedPoint: PropTypes.func,
  pointsList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      address: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  ),
}

// Set default props
Map.defaultProps = {
  selectedPoint: null,
  setSelectedPoint: () => {},
  pointsList: [],
  defaultCenter: defaultCenter,
  defaultZoom: defaultZoomValue,
}
